module.exports = __webpack_public_path__ + "assets/images/quote-right-white.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/quote-right-white.png
 ** module id = 29
 ** module chunks = 0
 **/